(ns manage.resource.adset-activation
  "Deprecated: use TSQ in `common.resource.query.adset-activation` instead"
  {:deprecated true}
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(def entity-name "Activation")

;; Get
(rf/reg-event-fx :resource.adset-activation/get-all
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :context)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db context url-context] :as cofx} [_ _page _search _sort-direction]]
    {:db (assoc db :resource.adset-activation/all {:state :pending :value []})
     :http
     {:method :get
      :uri (url-tpl/render :api/content-build-adset-activations
                           (assoc url-context :advertiser-id (:advertiser-id context)
                                  :adset-id (:adset-id context)))
      ;; :params (get-request-params page search sort-direction)
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adset-activation/get-all-success]
      :on-failure [:resource.adset-activation/get-all-failure]}}))

(rf/reg-event-db :resource.adset-activation/get-all-success
  (fn [db [_ items]]
    (assoc db :resource.adset-activation/all {:state :success
                                              :value (:data items)})))

(rf/reg-event-db :resource.adset-activation/get-all-failure
  (fn [db [_ _]]
    (assoc db :resource.adset-activation/all {:state :failure :value []})))

(rf/reg-sub :resource.adset-activation/all
  (fn [db _]
    (get-in db [:resource.adset-activation/all :value] [])))

;; update

(rf/reg-event-fx ::activation-update-success
  (fn [_ [_ resolve]]
    {:fx [[:dispatch [:resource.adset-activation/get-all]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :success
                       :message "Activation has been updated"}]]
          [:promise/resolve resolve]]}))

(rf/reg-event-fx ::activation-update-failure
  (fn [_ [event reject error]]
    {:fx [[:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :error
                       :message "Activation update failed"
                       :event event
                       :response error}]]
          [:promise/reject reject]]}))

(rf/reg-event-fx ::update-activation
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ resolve reject activation-id enabled?]]
    {:http
     {:method :put
      :uri (url-tpl/render :api/content-build-adset-activation (assoc url-context :activation-id activation-id))
      :headers {"Authorization" (:resource.user/token cofx)}
      :params {:enabled enabled?}
      :on-success [::activation-update-success resolve]
      :on-failure [::activation-update-failure reject]}}))

;; Init

(rf/reg-event-fx ::activation-init-success
  (fn [_ [_ resolve]]
    {:fx [[:dispatch [:resource.adset-activation/get-all]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :success
                       :message "Activation initialized. Please refresh the page."}]]
          [:promise/resolve resolve]]}))

(rf/reg-event-fx ::activation-init-failure
  (fn [_ [event reject error]]
    {:fx [[:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :error
                       :message "Activation initialization failed"
                       :event event
                       :response error}]]
          [:promise/reject reject]]}))

(rf/reg-event-fx ::init-activation
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ resolve reject]]
    {:http
     {:method :post
      :uri (url-tpl/render :api/content-build-adset-activations url-context)
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [::activation-init-success resolve]
      :on-failure [::activation-init-failure reject]}}))

;; Sync

(rf/reg-event-fx ::activation-sync-success
  (fn [_ [_ resolve]]
    {:fx [[:dispatch [:resource.adset-activation/get-all]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :success
                       :message "Syncing activation. Please refresh the page in a bit."}]]
          [:promise/resolve resolve]]}))

(rf/reg-event-fx ::activation-sync-failure
  (fn [_ [event reject error]]
    {:fx [[:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :error
                       :message "Syncing activation failed"
                       :event event
                       :response error}]]
          [:promise/reject reject]]}))

(rf/reg-event-fx ::sync-activation
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ resolve reject]]
    {:http
     {:method :put
      :uri (url-tpl/render :api/content-build-adset-sync-activation url-context)
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [::activation-sync-success resolve]
      :on-failure [::activation-sync-failure reject]}}))
